import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { useLojaLista } from "../../../hooks/queries/loja/useLojaLista/useLojaLista";
import { useCadastrarAgendamento } from "../../../hooks/queries/agendamento/useCadastrarAgendamento/useCadastrarAgendamento";
import { useVincularAgendamentoCliente } from "../../../hooks/queries/agendamento/useVincularAgendamentoCliente/useVincularAgendamentoCliente";
import { useContextSite } from "../../../context/Context";
import { useUserPermissions } from "../../../hooks/useUserPermissions";
import { useBrowserSessionStorage } from "../../../hooks/useBrowserSessionStorage";
import { Tracking } from "../../../services/Tracking";
import { TipoClienteEnum } from "../../../enums/tipoCliente";

export const useStoreV2 = () => {
  const navigate = useNavigate();
  const stepIndicator = useAgendamentoStepIndicator("hidden md:flex");
  const { data: lojas, isLoading, isError, error } = useLojaLista();
  const [uuidLoja, setUuidLoja] = useState("");
  const { setIsLoad } = useContextSite();
  const { userStorageData, isUserType } = useUserPermissions();
  const [uuidClienteAgendamento, , removeUuidClienteAgendamento] =
    useBrowserSessionStorage("@uuidClienteAgendamento");
  const { mutate: cadastrarAgendamento } = useCadastrarAgendamento();
  const { mutate: vincularAgendamentoCliente } =
    useVincularAgendamentoCliente();

  useEffect(() => {
    if (isLoading) {
      setIsLoad(true);
      return;
    }
    setIsLoad(false);
  }, [isLoading]);

  useEffect(() => {
    if (!isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = error as any;

    Tracking.error("mapa:agendamento/loja:listagem-lojas-falhou", { mensagem });
  }, [isError]);

  function submitAgendamento() {
    const isDespachante = isUserType(TipoClienteEnum.DESPACHANTE);
    const uuidCliente = isDespachante
      ? uuidClienteAgendamento
      : userStorageData?.uuidCliente;

    setIsLoad(true);
    cadastrarAgendamento(
      { uuidLoja },
      {
        onSuccess: ({ data }) => {
          vincularAgendamentoCliente(
            { uuid: data.uuid, uuidCliente },
            {
              onSuccess: () => {
                removeUuidClienteAgendamento();
                navigate(`/agendamento/${data.uuid}/servicos`);
              },
              onError: ({
                response: {
                  data: { mensagem },
                },
              }: any) => {
                Tracking.error("mapa:agendamento/loja:vincular-cliente-falhou", {
                  mensagem,
                });
              },
              onSettled: () => setIsLoad(false),
            },
          );
        },
        onError: ({
          response: {
            data: { mensagem },
          },
        }: any) => {
          Tracking.error("mapa:agendamento/loja:criar-agendamento-falhou", {
            mensagem,
          });
          setIsLoad(false);
        },
      },
    );
  }

  return {
    stepIndicator,
    lojas: lojas || [],
    uuidLoja,
    setUuidLoja,
    submitAgendamento,
  };
};
